/**
 * Punch Room/Area Guidance — service layer (Construction Gates Phase D trimmings). Backed by
 * api/punch-room-guidance.js (Supabase `punch_room_guidance_types` + `punch_room_guidance_items`).
 * Editable in TemplatesWorkspace — never static config, no deploy required.
 */

async function authHeaders() {
  const token = await window.__clerkGetToken()
  return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
}

async function call(method, body) {
  const res = await fetch('/api/punch-room-guidance', {
    method,
    headers: await authHeaders(),
    body: body ? JSON.stringify(body) : undefined,
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || ('Punch guidance request failed (' + res.status + ')'))
  return data
}

/** All room/area guidance types with their ordered items. */
export function getPunchRoomGuidanceTypes() {
  return call('GET').then(d => d.types)
}

export function createPunchGuidanceType(name) {
  return call('POST', { action: 'createType', name }).then(d => d.type)
}
export function renamePunchGuidanceType(id, name) {
  return call('POST', { action: 'renameType', id, name }).then(d => d.type)
}
export function deletePunchGuidanceType(id) {
  return call('POST', { action: 'deleteType', id })
}
export function movePunchGuidanceType(id, direction) {
  return call('POST', { action: 'moveType', id, direction })
}

export function createPunchGuidanceItem(typeId, text) {
  return call('POST', { action: 'createItem', typeId, text }).then(d => d.item)
}
export function updatePunchGuidanceItem(id, text) {
  return call('POST', { action: 'updateItem', id, text }).then(d => d.item)
}
export function deletePunchGuidanceItem(id) {
  return call('POST', { action: 'deleteItem', id })
}
export function movePunchGuidanceItem(id, direction) {
  return call('POST', { action: 'moveItem', id, direction })
}
